import _ from 'lodash'

function _reportError (signature) {
  console.error(
    'Validation rule error: ' + signature + ' has missing parameter(s)'
  )
  return [(v) => false || 'Validation rule error']
}

export const Rules = {
  accepted: [
    (v) =>
      ['yes', 'on', 1, true, '1', 'true'].includes(v) ||
            'Field must be accepted'
  ],
  accountNumber: [
    (v) => !v || /^[0-9]+$/.test(v) || 'Account Number must be numeric',
    (v) => !v || (v || '').length === 8 || 'Account Number must be 8 digits long'
  ],
  afterDate: (date = new Date()) => {
    return [
      (v) =>
        Date.parse(v) > Date.parse(date) ||
                'Date must be equal to or after ' +
                    date.getFullYear() +
                    '-' +
                    date.getMonth() +
                    '-' +
                    date.getDate()
    ]
  },
  afterOrEqualDate: (date = new Date()) => {
    return [
      (v) =>
        Date.parse(v) >= Date.parse(date) ||
                'Date must be equal to or after ' +
                    date.getFullYear() +
                    '-' +
                    date.getMonth() +
                    '-' +
                    date.getDate()
    ]
  },
  alpha: [(v) => !v || /[a-zA-Z\s]+$/.test(v) || 'Field must only contain letters'],
  alphaDash: [
    (v) => !v ||
      /^[\w\-\s]+$/.test(v) ||
            'Field must only contain letters, hyphens, and underscores'
  ],
  alphaNumeric: [
    (v) => !v ||
      /^[a-zA-Z0-9]+$/.test(v) ||
            'Field must only contain letters and numbers'
  ],
  alphaNumericSpace: [
    (v) => !v ||
            /^[a-zA-Z0-9\s]+$/.test(v) ||
            'Field must only contain letters and numbers'
  ],
  alphaNumericDash: [
    (v) => !v ||
      /^[a-zA-Z0-9-_]+$/.test(v) ||
            'Field must only contain letters, numbers, hyphens, and underscores'
  ],
  alphaNumericDashSpace: [
    (v) => !v ||
      /^$|^[a-zA-Z0-9-_,\s]+$/.test(v) ||
            'Field must only contain letters, numbers, hyphens, underscores, and spaces'
  ],
  alphaDashSpace: [
    (v) => !v ||
      /^$|^[a-zA-Z-_,\s]+$/.test(v) ||
      'Field must only contain letters, hyphens, underscores, and spaces'
  ],
  array: [(v) => Array.isArray(v) || 'Field must be an array'],
  beforeDate: (date = new Date()) => {
    return [
      (v) =>
        Date.parse(v) < Date.parse(date) ||
                'Date must be before ' +
                    date.getFullYear() +
                    '-' +
                    date.getMonth() +
                    '-' +
                    date.getDate()
    ]
  },
  beforeOrEqualDate: (model, date = new Date()) => {
    if (!(model instanceof Date)) {
      model = new Date(model)
    }
    return [
      Date.parse(model) <= Date.parse(date) ||
        'Date must be equal to or before ' +
        date.getDate() +
        '/' +
        (date.getMonth() + 1) +
        '/' +
        date.getFullYear()
    ]
  },
  between: (min = false, max = false) => {
    if (!min || !max) {
      return _reportError('between(min, max)')
    }
    return [
      (v) =>
        (v >= min && v <= max) ||
                'Field must be between ' + min + ' and ' + max
    ]
  },
  boolean: [(v) => typeof v === 'boolean' || 'Field must be true or false'],
  building_society_number: [
    (v) => !v || /[0-9]+$/.test(v) || 'Building society number must be numeric only',
    (v) => !v || /[0-9]{8,12}/.test(v) || 'Building society number must be 8-12 digits long'
  ],
  confirmed: (field = false, context = false) => {
    if (!field || !context) {
      return _reportError('confirmed(field, context)')
    }
    return [
      (v) =>
        context[field + '_confirmed'] === v || field + 's do not match'
    ]
  },
  crn: [
    (v) => !v || /^([a-zA-Z]){2}([0-9]){6}$/.test(v) || /^([0-9]){8}$/.test(v) || 'Required format 8 numbers or 2 letters followed by 6 numbers.'
  ],
  crnAlt: [
    (v) => !v || /^([a-zA-Z]){2}([0-9]){6}$/.test(v) ||
    /^([0-9]){8}$/.test(v) ||
    /^([0-9]){10}$/.test(v) ||
    'Required format 8 or 10 numbers, or 2 letters followed by 6 numbers.'
  ],
  dateEquals: (date = new Date()) => {
    return [
      (v) =>
        Date.parse(v) === Date.parse(date) ||
          'Date must be equal to or before ' +
              date.getFullYear() +
              '-' +
              date.getMonth() +
              '-' +
              date.getDate()
    ]
  },
  different: (field = false, context = false) => {
    if (!field || !context) {
      return _reportError('different(field, context)')
    }
    return [
      (v) => context[field] !== v || 'This field must not match ' + field
    ]
  },
  digits: (length = false) => {
    if (!length) {
      return _reportError('digits(length)')
    }
    return [(v) => !v || new RegExp('^[0-9]{' + length + '}$').test(v) || 'Must be ' + length + ' digits']
  },
  digitsBetween: (minLength = 0, maxLength = false) => {
    if (!maxLength) {
      return _reportError('digitsBetween(minLength, maxLength)')
    }
    return [
      (v) =>
        new RegExp('^[0-9]{' + minLength + ',' + maxLength + '}$').test(
          v
        ) ||
        'Field must be numeric and between ' +
            minLength +
            ' and ' +
            maxLength +
            ' long'
    ]
  },
  domain: [
    (v) =>
      /^(((?!-))(xn--|_{1,1})?[a-z0-9-]{0,61}[a-z0-9]{1,1}\.)*(xn--)?([a-z0-9][a-z0-9-]{0,60}|[a-z0-9-]{1,30}\.[a-z]{2,})$/.test(
        v
      ) || 'Must be a valid domain name'
  ],
  email: [
    (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v) || 'E-mail must be valid'
  ],
  endsWith: (model, ...params) => {
    if (!params.length) {
      return _reportError('endsWith(...params)')
    }
    let test = false
    for (let i = 0; i < params.length; i++) {
      if (model.endsWith(params[i])) {
        test = true
        break
      }
    }
    if (model !== 0 && model === false) {
      test = true
    }
    return [
      (v) =>
        test ||
        'Field must end with one of the following: [' + params.join(', ') + ']'
    ]
  },
  filled: [(v) => v !== '' || 'Field must not be empty'],
  gt: (num = false) => {
    if (num === false) {
      return _reportError('gt(num)')
    }
    return [(v) => v > num || 'Field must be greater than ' + num]
  },
  gte: (num = false) => {
    if (num === false) {
      return _reportError('gte(num)')
    }
    return [
      (v) => v >= num || 'Field must be greater than or equal to ' + num
    ]
  },
  in: (array = false) => {
    if (!array) {
      return _reportError('in(array)')
    }
    return [(v) => array.indexOf(v) >= 0 || 'Field must be a valid option']
  },
  integer: [
    (v) =>
      !!(isNaN(v) ? false : parseFloat(v) | (parseFloat(v) === 0)) ||
            'Field must be an integer'
  ],
  ipv4: [
    (v) =>
      /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
        .test(v) || 'Field must be a valid IPv4 Address'
  ],
  ipv6: [
    (v) =>
      /^s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]d|1dd|[1-9]?d)(.(25[0-5]|2[0-4]d|1dd|[1-9]?d)){3}))|:)))(%.+)?s*$/
        .test(v) || 'Field must be a valid IPv6 Address'
  ],
  lt: (num = false) => {
    if (num === false) {
      return _reportError('lt(num)')
    }
    return [(v) => v < num || 'Field must be less than ' + num]
  },
  lte: (num = false) => {
    if (num === false) {
      return _reportError('lte(num)')
    }
    return [
      (v) => v <= num || 'Field must be less than or equal to ' + num
    ]
  },
  max: (model, num = false) => {
    if (num === false) {
      return _reportError('max(model, num)')
    }
    let test = false
    if (model === null || model.length === 0) {
      return true
    }
    if (typeof model === 'string' || Array.isArray(model)) {
      test = model.length <= num
      return [(v) => test || 'Field must be shorter than ' + num]
    } else if (typeof model === 'number') {
      test = model <= num
      return [(v) => test || 'Field must be less than ' + num]
    }
    return [(v) => test || 'Invalid type passed in field']
  },
  maxFileSize: [
    (v) => !v || v.size <= (1024 * 1024 * 15) || 'File too big. 15MB max size'
  ],
  min: (model, num = false) => {
    if (num === false) {
      return _reportError('min(model, num)')
    }
    let test = false
    if (typeof model === 'string' || Array.isArray(model)) {
      test = model.length >= num
      return [(v) => test || 'Field must be longer than ' + num]
    } else if (typeof v === 'number') {
      test = model >= num
      return [(v) => test || 'Field must be more than ' + num]
    }
    return [(v) => test || 'Invalid type passed in field']
  },
  name: [
    (v) => (v || '').indexOf(' ') < 0 || 'No spaces are allowed',
    (v) => !v || /^[a-zA-Z-'’]+$/g.test(v) || 'Field must only contain letters, apostrophe and hyphens'
  ],
  ni_number: [
    (v) =>
      !v || (!['D', 'F', 'I', 'Q', 'U', 'V'].includes(v.charAt(0).toUpperCase()) && !['D', 'F', 'I', 'Q', 'U', 'V'].includes(v.charAt(1).toUpperCase())) || 'The letters D, F, I, Q, U or V cannot be used in the prefix',
    (v) =>
      !v || !/^(.O)/gi.test(v) || 'The letter O cannot be used as the second character in the prefix',
    (v) =>
      !v || !/^(BG|GB|KN|NK|NT|ZZ)/gi.test(v) || 'BG, GB, KN, NK, NT or ZZ cannot be used as a prefix',
    (v) =>
      !v || /^[A-Z]{2}[0-9]{6}[A-Z]{1}$/gi.test(v) || 'National insurance numbers (NINo) should appear in the following combination of letters and numbers - two letters, six numbers, one letter. For example: QQ123456C.',
    (v) =>
      !v || /[A-D,F,M]$/gi.test(v) || 'Only the letters A, B, C and D should be used as a suffix'
  ],
  noSpaces: [(v) => (v || '').indexOf(' ') < 0 || 'No spaces are allowed'],
  notIn: (array = false) => {
    if (!array) {
      return _reportError('notIn(array)')
    }
    return [
      (v) => array.indexOf(v) === -1 || 'Field must be a valid option'
    ]
  },
  notRegex: (regex = false) => {
    if (!regex) {
      return _reportError('notRegex(regex)')
    }
    return [
      (v) => !new RegExp(regex).test(v) || 'Field must be a valid value'
    ]
  },
  numeric: [(v) => !v || /^[0-9]+$/.test(v) || 'Field must be numeric'],
  optionalPassword: [
    (v) => !v || v.length >= 8 ||
            'Password must be more than 8 characters'
  ],
  password: [
    (v) =>
      (v || '').length >= 8 || 'Password must be more than 8 characters'
  ],
  phone: [
    (v) =>
      !v || /^(\+?)[0-9]{11,13}$/.test(v) ||
            'Between 11-13 digits required (+, 0-9)'
  ],
  postcode: [
    (v) =>
      !v || /^(\+?)[A-Za-z0-9\s]{5,8}$/.test(v) || 'Postcode must be between 5-8 characters containing only letters and numbers'
  ],
  regex: (regex = false) => {
    if (!regex) {
      return _reportError('notRegex(regex)')
    }
    return [
      (v) => new RegExp(regex).test(v) || 'Field must be a valid value'
    ]
  },
  required: [(v) => (v === 0 ? true : !!v || 'This field is required')],
  requiredCandidate: (v) => (v === 0 ? true : !!v || 'This field is required'),
  requiredOption: (data) => {
    return [(v) => !_.isEmpty(data) || 'This field is required']
  },
  requiredNamed: (fieldName = false) => {
    return [
      (v) =>
        v === 0
          ? true
          : !!v || (fieldName || 'This field') + ' is required'
    ]
  },
  same: (field = false, context = false) => {
    if (!field || !context) {
      return _reportError('same(field, context)')
    }
    return [
      (v) => context[field] !== v || 'This field must match ' + field
    ]
  },
  size: (fldSize, num = false) => {
    if (num === false) {
      return _reportError('size(num)')
    }
    let test = false
    if (fldSize === null || fldSize.length === 0) {
      return true
    }
    if (typeof fldSize === 'string' || Array.isArray(fldSize)) {
      test = fldSize.length === num
      return [(v) => test || 'Field must be have a length of ' + num]
    } else if (typeof fldSize === 'number') {
      test = fldSize >= num
      return [(v) => test || 'Field must be ' + num]
    }
    return [(v) => test || 'Invalid type passed in field']
  },
  sortCode: [
    (v) => !v || /^([0-9]){2}([-])([0-9]){2}([-])([0-9]){2}/.test(v) || 'Sort code must be numeric only in the format 00-00-00',
    (v) => !v || (v || '').length === 8 || 'Sort code must be 8 digits long'
  ],
  startsWith: (model, ...params) => {
    if (!params.length) {
      return _reportError('startsWith(...params)')
    }
    let test = false
    for (let i = 0; i < params.length; i++) {
      if (model.startsWith(params[i])) {
        test = true
        break
      }
    }
    if (model !== 0 && model === false) {
      test = true
    }
    return [
      (v) =>
        test ||
                'Field must start with one of the following: ' +
                    params.join(', ')
    ]
  },
  string: [(v) => !v || typeof v === 'string' || 'Field must be a string'],
  summary: [
    (v) =>
      (v || '').length <= 100 ||
            'Summary must be less than 100 characters'
  ],
  url: [
    v => /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(v) || !v || 'Field must be a valid URL'
  ],
  uuid: [
    (v) =>
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(
        v
      ) || 'Field must be a valid UUID'
  ]
}
